module.exports = __webpack_public_path__ + "images/refunds_0da4b86.svg";